import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import { useAppSelector } from "../../Redux/app/hooks";
import { buySellAmount, formatNumber } from "../../helpers/helper";
function FXSOrderConfirmationDetail({
  confirm,
  primaryCurrecnyValue,
  secondaryCurrecnyValue,
  ask_value,
  bid_value,
  userType,
  selectedPortfolios,
  allocate_portfolio,
  custodianName,
  clientMarkupData,
  conValue
}: any) {
  console.log(conValue, "conValue")
  const form = useAppSelector((state) => state.orderSection.form_data);
  const totalEstMarkup = selectedPortfolios.reduce((sum: any, item: any) => sum + item.est_markup, 0);
  return (
    <>
      <div className="order-confirmation-table">
        {!conValue ? (
          <table>
            <thead className="thead-color">
              <tr key={"FXBO-001"}>
                {userType === "internal" && <th>Entity</th>}
                {userType !== "internal" && <th>Entity</th>}
                <th>Description</th>
                <th>Transaction</th>
                <th>Type</th>
                <th>Duration</th>
                <th>Price</th>
                {((userType === "internal" && !conValue) || userType === "internal_destributor") && <th>Est. Markup</th>}
                <th className="h-est-width">Est. Total</th>
              </tr>
            </thead>
            <tbody>
              <tr key={"FXBO-002"} className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
                {userType === "internal" && <td>{custodianName}</td>}
                {userType !== "internal" && <td>EMFI Capital</td>}
                <td>
                  <span>{primaryCurrecnyValue}</span>
                  <div className="tooltiptext">
                    <p>{primaryCurrecnyValue}</p>
                  </div>
                </td>
                <td>{form.direction.toUpperCase()}</td>
                <td>{form.order_type === "stop_limit" ? "STOP LIMIT" : form.order_type.toUpperCase()}</td>
                <td>
                  <span>{confirm.time.replace(/_/g, " ")}</span>
                </td>
                <td>
                  {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                    <b>N/A</b>
                  ) : (
                    <>{form.direction.toLowerCase() === "sell" && <b className="width-100">{Number(confirm.price).toFixed(5)}</b>}</>
                  )}
                </td>
                {(userType === "internal" || userType === "internal_destributor") && (
                  <td>
                    <b>0</b>
                  </td>
                )}
                <td>
                  {bid_value === 0 && form.order_type.toLowerCase() === "market" ? (
                    <b className="width-100">{buySellAmount(formatNumber(confirm.quantity), form.direction.toLowerCase())}</b>
                  ) : (
                    <>{<b className="width-100">{buySellAmount(formatNumber(confirm.quantity, 2), form.direction.toLowerCase())}</b>}</>
                  )}
                </td>
              </tr>
              {/* second TR only Forex */}
              <tr key={"FXBO-003"} className={`${form.direction.toLowerCase() === "buy" ? "sell" : "buy"}-row divider-allocation`}>
                {userType === "internal" && <td>{custodianName}</td>}
                {userType !== "internal" && <td>EMFI Capital</td>}
                <td>{secondaryCurrecnyValue}</td>
                <td>{form.direction.toLowerCase() === "buy" ? "SELL" : "BUY"}</td>
                <td>{form.order_type === "stop_limit" ? "STOP LIMIT" : form.order_type.toUpperCase()}</td>
                <td>{confirm.time.replace(/_/g, " ")}</td>
                <td>
                  {/* <b>1.09580</b> */}
                  {bid_value === 0 && form.order_type.toLowerCase() === "market" ? (
                    <b>N/A</b>
                  ) : (
                    <>{<b className="width-100">{Number(confirm.price).toFixed(5)}</b>}</>
                  )}
                </td>
                {(userType === "internal" || userType === "internal_destributor") && (
                  <td>
                    <b>0</b>
                  </td>
                )}
                <td>
                  {form.order_type.toLowerCase() === "market" ? (
                    <>
                      {bid_value === 0 && form.order_type.toLowerCase() === "market" ? (
                        <b>N/A</b>
                      ) : (
                        <b className="width-100">
                          {buySellAmount(
                            new Intl.NumberFormat().format(confirm.quantity.replace(",", "") * confirm.price),
                            form.direction.toLowerCase() === "buy" ? "sell" : "buy"
                          )}
                        </b>
                      )}
                    </>
                  ) : (
                    <>
                      {
                        <b className="width-100">
                          {buySellAmount(
                            new Intl.NumberFormat().format(confirm.quantity.replace(",", "") * confirm.price),
                            form.direction.toLowerCase() === "buy" ? "sell" : "buy"
                          )}
                        </b>
                      }
                    </>
                  )}
                </td>
              </tr>
              {/* For client information */}
              {(userType === "internal") &&
                selectedPortfolios.map(
                  (allocates_input: any, index: any) =>
                    allocates_input.client_id !== null
                    && allocates_input.markup_value !== 0
                    && allocates_input.markup_value !== null
                    && allocates_input.markup_value !== undefined
                    && Number(allocates_input.client_id) !== 0 && (
                      <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "sell" : "buy"}-row `}>
                        {userType === "internal" &&
                          <td>- {allocate_portfolio.filter((item: any) => item.id === allocates_input.client_id).map((item: any) => item.name)}</td>
                        }
                        {userType === "internal_destributor" &&
                          <td>- {allocate_portfolio.filter((item: any) => item.counterparty_id === allocates_input.client_id).map((item: any) => item.title)}</td>
                        }
                        <td>{secondaryCurrecnyValue}</td>
                        <td>{form.direction.toLowerCase() === "buy" ? "SELL" : "BUY"}</td>
                        <td>{form.order_type === "stop_limit" ? "STOP LIMIT" : form.order_type.toUpperCase()}</td>
                        <td>{confirm.time.replace(/_/g, " ")}</td>
                        <td>
                          {ask_value === 0 && form.order_type.toLowerCase() === "market" ? (
                            <b>N/A</b>
                          ) : (
                            // <>{<b>{Number(confirm.price).toFixed(5)}</b>}</>
                            <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(5)}</b>}</>
                          )}
                        </td>
                        {(userType === "internal" || userType === "internal_destributor") && (
                          <td>
                            <b>{allocates_input.est_markup}</b>
                          </td>
                        )}
                        <td>
                          {form.order_type.toLowerCase() === "market" ? (
                            <>
                              {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.isInverse === false ? (
                                <b>N/A</b>
                              ) : (
                                <b className="width-100">
                                  {buySellAmount(
                                    new Intl.NumberFormat().format(allocates_input.qty.replace(",", "") * allocates_input.markup_price),
                                    form.direction.toLowerCase() === "buy" ? "sell" : "buy"
                                  )}
                                </b>
                              )}
                            </>
                          ) : (
                            <>
                              {
                                <b className="width-100">
                                  {buySellAmount(
                                    new Intl.NumberFormat().format(allocates_input.qty.replace(",", "") * allocates_input.markup_price),
                                    form.direction.toLowerCase() === "buy" ? "sell" : "buy"
                                  )}
                                </b>
                              }
                            </>
                          )}
                        </td>
                      </tr>
                    )
                )}
              {/* Sell */}
              {userType === "internal_destributor" &&
                selectedPortfolios.map(
                  (allocates_input: any, index: any) =>
                    allocates_input.client_id !== null &&
                    Number(allocates_input.client_id) !== 0
                    && allocates_input.est_markup !== 0
                    && allocates_input.markup_value !== null
                    && allocates_input.markup_value !== undefined
                    && (
                      <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row `}>
                        <td className={"td-text-indent"}>
                          - {allocate_portfolio.filter((item: any) => item.counterparty_id === allocates_input.client_id).map((item: any) => item.title)}
                        </td>
                        <td>{secondaryCurrecnyValue}</td>
                        <td>{form.direction.toLowerCase() === "buy" ? "BUY" : "SELL"}</td>
                        <td>{form.order_type.toUpperCase()}</td>
                        <td>{confirm.time.replace(/_/g, " ")}</td>
                        <td>
                          {ask_value === 0 && form.order_type.toLowerCase() === "market" ? (
                            <b>N/A</b>
                          ) : (
                            // <>{<b>{Number(confirm.price).toFixed(5)}</b>}</>
                            <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(5)}</b>}</>
                          )}
                        </td>
                        {(userType === "internal" || userType === "internal_destributor") && (
                          <td>
                            <b>{allocates_input.est_markup}</b>
                          </td>
                        )}
                        <td>
                          {form.order_type.toLowerCase() === "market" ? (
                            <>
                              {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.isInverse === false ? (
                                <b>N/A</b>
                              ) : (
                                <b className="width-100">
                                  {buySellAmount(
                                    new Intl.NumberFormat().format(allocates_input.qty.replace(",", "") * allocates_input.markup_price),
                                    form.direction.toLowerCase() === "buy" ? "buy" : "sell"
                                  )}
                                </b>
                              )}
                            </>
                          ) : (
                            <>
                              {
                                <b className="width-100">
                                  {buySellAmount(
                                    new Intl.NumberFormat().format(allocates_input.qty.replace(",", "") * allocates_input.markup_price),
                                    form.direction.toLowerCase() === "buy" ? "buy" : "sell"
                                  )}
                                </b>
                              }
                            </>
                          )}
                        </td>
                      </tr>
                    )
                )}
              {/* Buy */}
              {userType === "internal_destributor" &&
                selectedPortfolios.map(
                  (allocates_input: any, index: any) =>
                    allocates_input.client_id !== null &&
                    Number(allocates_input.client_id) !== 0
                    && allocates_input.est_markup !== 0
                    && allocates_input.markup_value !== null
                    && allocates_input.markup_value !== undefined
                    && (
                      <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "sell" : "buy"}-row `}>
                        <td className={"td-text-indent"}>
                          - {allocate_portfolio.filter((item: any) => item.counterparty_id === allocates_input.client_id).map((item: any) => item.title)}
                        </td>
                        <td>{primaryCurrecnyValue}</td>
                        <td>{form.direction.toLowerCase() === "buy" ? "SELL" : "BUY"}</td>
                        <td>{form.order_type.toUpperCase()}</td>
                        <td>{confirm.time.replace(/_/g, " ")}</td>
                        <td>
                          {ask_value === 0 && form.order_type.toLowerCase() === "market" ? (
                            <b>N/A</b>
                          ) : (
                            // <>{<b>{Number(confirm.price).toFixed(5)}</b>}</>
                            <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(5)}</b>}</>
                          )}
                        </td>
                        {(userType === "internal" || userType === "internal_destributor") && (
                          <td>
                            <b>0</b>
                          </td>
                        )}
                        <td>
                          {form.order_type.toLowerCase() === "market" ? (
                            <>
                              {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.isInverse === false ? (
                                <b>N/A</b>
                              ) : (
                                <b className="width-100">
                                  {buySellAmount(
                                    formatNumber(confirm.quantity, 2), form.direction.toLowerCase() === "buy" ? "sell" : "buy"
                                  )}
                                </b>
                              )}
                            </>
                          ) : (
                            <>
                              {
                                <b className="width-100">
                                  {buySellAmount(
                                    formatNumber(confirm.quantity, 2), form.direction.toLowerCase() === "buy" ? "sell" : "buy"
                                  )}
                                </b>
                              }
                            </>
                          )}
                        </td>
                      </tr>
                    )
                )}
            </tbody>
          </table>
        ) : (
          <table>
            <thead className="thead-color">
              <tr key={"FXBO-001"}>
                <th>Description</th>
                <th>Transaction</th>
                <th>Type</th>
                <th>Duration</th>
                <th>Price</th>
                <th>Quantity</th>
                {(userType === "internal_destributor") && <th>Est. Markup</th>}
                <th className="h-est-width">Est. Total</th>
              </tr>
            </thead>
            <tbody>
              <tr key={"FXBO-002"} className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>

                <td>
                  <span>{conValue?.DisplaySecurity}</span>
                  <div className="tooltiptext">
                    <p>{conValue?.DisplaySecurity}</p>
                  </div>
                </td>
                <td>{form.direction.toUpperCase()}</td>
                <td>{form.order_type === "stop_limit" ? "STOP LIMIT" : form.order_type.toUpperCase()}</td>
                <td>
                  <span>{confirm.time.replace(/_/g, " ")}</span>
                </td>
                <td>
                  {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
                    <b>N/A</b>
                  ) : (
                    <>{form.direction.toLowerCase() === "sell" && <b className="width-100">{Number(confirm.price).toFixed(5)}</b>}</>
                  )}
                </td>

                <td className="w-[200px]">
                  <b>{form.quantity} (Lot size 1 = {new Intl.NumberFormat().format(conValue?.Multiplier)}) </b>
                </td>
                {
                  userType === "internal_destributor" && (
                    <td className="w-[70px]">
                      <b className="width-100">0</b>  </td>
                  )
                }
                <td className="w-[150px]">

                  <b className="width-100">{`(${new Intl.NumberFormat().format(confirm.quantity * Number(confirm.price) * conValue?.Multiplier)}) ${conValue?.Currency}`}</b>

                </td>
              </tr>
              {/* second TR only Forex */}
              {conValue && (userType === "internal_destributor") &&
                selectedPortfolios.map(
                  (allocates_input: any, index: any) =>
                    allocates_input.client_id !== null &&
                    Number(allocates_input.client_id) !== 0
                    && allocates_input.est_markup !== 0
                    && allocates_input.markup_value !== null
                    && allocates_input.markup_value !== undefined
                    && (
                      <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "sell" : "buy"}-row `}>
                        <td className={"td-text-indent"}>
                          - {allocate_portfolio.filter((item: any) => item.counterparty_id === allocates_input.client_id).map((item: any) => item.title)}
                        </td>

                        <td>{form.direction.toLowerCase() === "buy" ? "SELL" : "BUY"}</td>
                        <td>{form.order_type.toUpperCase()}</td>
                        <td>{confirm.time.replace(/_/g, " ")}</td>
                        <td>
                          {bid_value === 0 && form.order_type.toLowerCase() === "market" ? (
                            <b>N/A</b>
                          ) : (
                            // <>{<b>{Number(confirm.price).toFixed(5)}</b>}</>
                            <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(5)}</b>}</>
                          )}
                        </td>
                        <td className="w-[200px]">
                          <b>{form.quantity} (Lot size 1 = {new Intl.NumberFormat().format(conValue?.Multiplier)}) </b>
                        </td>
                        {(userType === "internal" || userType === "internal_destributor") && (
                          <td>
                            <b>{allocates_input.est_markup}</b>
                          </td>
                        )}
                        <td>
                          {form.order_type.toLowerCase() === "market" ? (
                            <>
                              {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.isInverse === false ? (
                                <b>N/A</b>
                              ) : (
                                <b className="width-100">
                                  {`${new Intl.NumberFormat().format(allocates_input?.inverse_currency_amt_display)} ${conValue?.Currency}`}
                                </b>
                              )}
                            </>
                          ) : (
                            <>
                              {
                                <b className="width-100">
                                  {`${new Intl.NumberFormat().format(allocates_input?.inverse_currency_amt_display)} ${conValue?.Currency}`}
                                </b>
                              }
                            </>
                          )}
                        </td>
                      </tr>
                    )
                )}
              {/* For client information */}

            </tbody>
          </table>
        )}
        {!conValue ? <>
          {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
            <></>
          ) : (
            <>
              {form.direction.toLowerCase() === "sell" && userType === "internal" && (
                <p>
                  At an exchange rate {confirm.price !== 0 ? Number(confirm.price).toFixed(5) : ""} of {primaryCurrecnyValue} to{" "}
                  {secondaryCurrecnyValue} estimated receivable {secondaryCurrecnyValue}{" "}
                  {new Intl.NumberFormat().format(confirm.quantity * confirm.price)} against {primaryCurrecnyValue} {formatNumber(confirm.quantity)}{" "}
                  (Total Est. Markup : {secondaryCurrecnyValue} {totalEstMarkup})
                </p>
              )}
              {form.direction.toLowerCase() === "sell" && userType !== "internal" && (
                <p>
                  At an exchange rate {confirm.price !== 0 ? Number(confirm.price).toFixed(5) : ""} of {primaryCurrecnyValue} to{" "}
                  {secondaryCurrecnyValue} estimated receivable {secondaryCurrecnyValue}{" "}
                  {new Intl.NumberFormat().format(confirm.quantity * confirm.price)} against {primaryCurrecnyValue} {formatNumber(confirm.quantity)}{" "}
                </p>
              )}
            </>
          )}
        </>
          :
          <>
            {bid_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "sell" ? (
              <></>
            ) : (
              <>
                {form.direction.toLowerCase() === "sell" && (
                  <p>
                    At a price of {confirm.price !== 0 ? Number(confirm.price).toFixed(2) : ""} per share, the value of this trade is estimated at{" "}
                    {new Intl.NumberFormat().format(confirm.quantity * confirm.price * conValue?.Multiplier)} {conValue?.Currency}
                  </p>
                )}

              </>
            )}
          </>
        }
      </div>
    </>
  );
}

export default FXSOrderConfirmationDetail;
